import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27 14.8 24.4 12 27 9.2 25.8 8 22 12l3.8 4zM15 2H9a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zm4 18H9V4h5v5h5zM1 9.2 3.6 12 1 14.8 2.2 16 6 12 2.2 8z"
    }, null, -1)
  ]))]))
}
export default { render: render }